class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  // renderContents(parsedState) {
  //   this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
  //   this.productId = parsedState.id;
  //   this.getSectionsToRender().forEach((section => {
  //     const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
  //     sectionElement.innerHTML =
  //         this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
  //   }));

  //   setTimeout(() => {
  //     this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
  //     this.open();
  //   });
  // }


  renderContents(parsedState) {
  this.productId = parsedState.id;

  // Cart me product add hone ke baad old empty state hatao
  this.classList.remove('is-empty');

  const currentDrawerInner = this.querySelector('.drawer__inner');

  if (currentDrawerInner) {
    currentDrawerInner.classList.remove('is-empty');
  }

  this.getSectionsToRender().forEach((section) => {
    const sectionHTML =
      parsedState.sections &&
      parsedState.sections[section.id];

    if (!sectionHTML) {
      console.warn(
        `[CartDrawer] Section HTML missing: ${section.id}`
      );
      return;
    }

    const sectionElement = section.selector
      ? document.querySelector(section.selector)
      : document.getElementById(section.id);

    if (!sectionElement) {
      console.warn(
        `[CartDrawer] Target element missing: ${section.selector || section.id}`
      );
      return;
    }

    const newHTML = this.getSectionInnerHTML(
      sectionHTML,
      section.selector
    );

    sectionElement.innerHTML = newHTML;
  });

  // New rendered markup me bhi empty classes remove karo
  this.classList.remove('is-empty');

  const updatedDrawerInner = this.querySelector('.drawer__inner');

  if (updatedDrawerInner) {
    updatedDrawerInner.classList.remove('is-empty');
  }

  setTimeout(() => {
    const overlay = this.querySelector('#CartDrawer-Overlay');

    if (overlay) {
      overlay.addEventListener(
        'click',
        this.close.bind(this),
        { once: true }
      );
    }

    this.open();
  }, 50);
}

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);



  (function() {
    const slider = document.querySelector('.cart-announcement-slider');
    if (!slider) return;

    const track = slider.querySelector('.cart-announcement-track');
    const slides = slider.querySelectorAll('.cart-announcement-slide');
    const prevBtn = slider.querySelector('.cart-announcement-arrow.prev');
    const nextBtn = slider.querySelector('.cart-announcement-arrow.next');
    const dotsContainer = slider.querySelector('.cart-announcement-dots');

    if (slides.length === 0) {
      slider.style.display = 'none';
      return;
    }

    let currentIndex = 0;
    let autoplayInterval;

    // Create dots
    slides.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.classList.add('cart-announcement-dot');
      if (index === 0) dot.classList.add('active');
      dot.setAttribute('aria-label', `Go to announcement ${index + 1}`);
      dot.addEventListener('click', () => goToSlide(index));
      dotsContainer.appendChild(dot);
    });

    const dots = slider.querySelectorAll('.cart-announcement-dot');

    function updateSlider() {
      track.style.transform = `translateX(-${currentIndex * 100}%)`;
      
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === currentIndex);
      });
    }

    function goToSlide(index) {
      currentIndex = index;
      updateSlider();
      resetAutoplay();
    }

    function nextSlide() {
      currentIndex = (currentIndex + 1) % slides.length;
      updateSlider();
    }

    function prevSlide() {
      currentIndex = (currentIndex - 1 + slides.length) % slides.length;
      updateSlider();
    }

    function startAutoplay() {
      if (slides.length > 1) {
        autoplayInterval = setInterval(nextSlide, 4000);
      }
    }

    function resetAutoplay() {
      clearInterval(autoplayInterval);
      startAutoplay();
    }

    // Event listeners
    nextBtn.addEventListener('click', () => {
      nextSlide();
      resetAutoplay();
    });

    prevBtn.addEventListener('click', () => {
      prevSlide();
      resetAutoplay();
    });

    // Hide arrows if only one slide
    if (slides.length <= 1) {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
      dotsContainer.style.display = 'none';
    }

    // Start autoplay
    startAutoplay();

    // Pause on hover
    slider.addEventListener('mouseenter', () => clearInterval(autoplayInterval));
    slider.addEventListener('mouseleave', startAutoplay);
  })();



